import { createApp } from 'vue'
import router from '@/app/router'
import { initializeServices } from '@/app/utils/initializeServices'
import { extractParamsFromUrl } from '@/shared/utils/UrlUtil'
import { BuildMode } from '@/shared/types/BuildMode'
import App from './app/App.vue'
import { debug } from './shared/utils/debug'

const BUILD_MODE = BuildMode.web

if (import.meta.env.VITE_APP_ENV !== 'production') {
  sessionStorage.setItem('IL_debug', 'true')
}

const renderWebApp = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const params = extractParamsFromUrl<any>()
  debug('params_web_mode', { ...params, token: 'hidden' })

  const props = {
    buildMode: BUILD_MODE,
    params
  }
  const webApp = createApp(App, {
    showOnly: params.showOnly,
    activeTabs: params.activeTabs
  })
  initializeServices({ app: webApp, params, buildMode: BUILD_MODE })
  webApp.use(router(props))
  webApp.mount('#app')
}

renderWebApp()
